export default (function (_ref) {
  var request = _ref.request;
  return {
    planEnvmtAdd: function planEnvmtAdd(data) {
      return request({
        url: '/grow/planEnvmt/add',
        method: 'post',
        data: data
      });
    },
    planEnvmtModify: function planEnvmtModify(data) {
      return request({
        url: "/grow/planEnvmt/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    planEnvmtDel: function planEnvmtDel(id) {
      return request({
        url: "/grow/planEnvmt/".concat(id, "/del"),
        method: 'delete'
      });
    },
    planEnvmtQuery: function planEnvmtQuery(planId, params) {
      return request({
        url: "/grow/planEnvmt/".concat(planId, "/query"),
        method: 'get',
        params: params
      });
    },
    planEnvmtDetail: function planEnvmtDetail(id) {
      return request({
        url: "/grow/planEnvmt/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});